import { createAnalyticsTracker } from 'v2/analytics/events';

export const trackIntegrationPageManageMetadataEvent = createAnalyticsTracker(
  'integrationPageManageMetadata',
);
